/* eslint-disable no-shadow,consistent-return,no-param-reassign */
// import router from '@/router';
import apiSetting from '@/services/jApiSetting';
import apiTemplate from '@/services/jApiTemplate';

const state = {
  // Set default state(s) here
  applications_list: [],
  application_detail: null,
  pages_list: [],
  group_applications_list: [],
  group_relations_list: [],
  template_apps_list: [],
  template_pages_list: [],
  portal_detail: null,
  pages_portal_list: [],
  standalone_list: [],
  company_settings: [],
  payroll_company_config: [],
  is_sidebar_minimized: true,
  user_company_setting: null,
};

const mutations = {
  setApplicationsList(state, payload) {
    state.applications_list = payload;
  },
  setApplicationDetail(state, payload) {
    state.application_detail = payload;
  },
  setPagesList(state, payload) {
    state.pages_list = payload;
  },
  setGroupApplicationsList(state, payload) {
    state.group_applications_list = payload;
  },
  setGroupRelationsList(state, payload) {
    state.group_relations_list = payload;
  },
  setTemplateAppsList(state, payload) {
    state.template_apps_list = payload;
  },
  setTemplateAppPagesList(state, payload) {
    state.template_pages_list = payload;
  },
  setPortalDetail(state, payload) {
    state.portal_detail = payload;
  },
  setPagesPortalList(state, payload) {
    state.pages_portal_list = payload;
  },
  setStandaloneList(state, payload) {
    state.standalone_list = payload;
  },
  setCompanySetting(state, payload) {
    state.company_settings = payload;
  },
  setPayrollCompanyConfig(state, payload) {
    state.payroll_company_config = payload;
  },
  setSidebarMinimized(state, payload) {
    state.is_sidebar_minimized = payload;
  },
  setUserCompanySetting(state, payload) {
    state.user_company_setting = payload;
  },
};

const actions = {
  // application
  async actionGetApplicationsList({ dispatch, commit }, data) {
    // dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiSetting.getApplicationsList(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        commit('setApplicationsList', res.data);
        // dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
    } catch (err) {
      // dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async actionGetApplicationDetail({ dispatch, commit }, { applicationId, param }) {
    // dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiSetting.getApplicationDetail(applicationId, param);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        commit('setApplicationDetail', res.data);
        return res.data;
        // dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
    } catch (err) {
      // dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async actionCreateApplication({ dispatch }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiSetting.createApplication(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
      return res;
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
      return err.response.data;
    }
  },

  async actionUpdateApplication({ dispatch, commit }, { applicationId, param }) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiSetting.updateApplication(applicationId, param);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        commit('setApplicationDetail', res.data);
        dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
      return res;
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
      return err.response.data;
    }
  },

  async actionDeleteApplication({ dispatch }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiSetting.deleteApplication(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
      return res;
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
      return err.response.data;
    }
  },

  // pages
  async actionGetPagesList({ dispatch, commit }, { applicationId, param }) {
    // dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiSetting.getPagesList(applicationId, param);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        commit('setPagesList', res.data);
        // dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
      return res;
    } catch (err) {
      // dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
      return err.response.data;
    }
  },

  async actionCreatePage({ dispatch }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiSetting.createPage(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
      return res;
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
      return err.response.data;
    }
  },

  async actionUpdatePage({ dispatch }, { parameter, useLoading }) {
    if (useLoading) {
      dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    }
    try {
      const res = await apiSetting.updatePage(parameter);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else if (!res.error) {
        if (useLoading) {
          dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
        }
      }
      return res;
    } catch (err) {
      if (useLoading) {
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
      return err.response.data;
    }
  },

  async actionDeletePage({ dispatch }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiSetting.deletePage(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
      return res;
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
      return err.response.data;
    }
  },

  // group application
  async actionGetGroupApplicationsList({ dispatch, commit }, data) {
    // dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiSetting.getGroupApplicationsList(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        commit('setGroupApplicationsList', res.data);
        // dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
    } catch (err) {
      // dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async actionGetGroupApplicationsDetail({ dispatch, commit }, data) {
    try {
      const res = await apiSetting.getGroupApplicationsDetail(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        commit('setGroupApplicationsList', res.data);
        return res.data;
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async actionCreateGroupApplication({ dispatch }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiSetting.createGroupApplication(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
      return res;
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
      return err.response.data;
    }
  },

  async actionUpdateGroupApplication({ dispatch }, { groupId, param }) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiSetting.updateGroupApplication(groupId, param);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
      return res;
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
      return err.response.data;
    }
  },

  async actionDeleteGroupApplication({ dispatch }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiSetting.deleteGroupApplication(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
      return res;
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
      return err.response.data;
    }
  },

  // group relation
  async actionGetGroupRelationsList({ dispatch, commit }, data) {
    // dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiSetting.getGroupRelationsList(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        commit('setGroupRelationsList', res.data);
        return res.data;
        // dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
    } catch (err) {
      // dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async actionCreateGroupRelation({ dispatch }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiSetting.createGroupRelation(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
      return res;
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
      return err.response.data;
    }
  },

  async actionUpdateGroupRelation({ dispatch }, { groupId, param }) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiSetting.updateGroupRelation(groupId, param);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
      return res;
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
      return err.response.data;
    }
  },

  async actionDeleteGroupRelation({ dispatch }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiSetting.deleteGroupRelation(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
      return res;
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
      return err.response.data;
    }
  },

  // others
  async actionGetListIcons({ dispatch }, data) {
    // dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiSetting.getListIcons(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        // dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
      return res;
    } catch (err) {
      // dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
      return err.response.data;
    }
  },

  // template
  async actionGetTemplateApplications({ dispatch, commit }, data) {
    // dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiTemplate.getTemplateApplications(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        commit('setTemplateAppsList', res.data);
        // dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
    } catch (err) {
      // dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async actionGetTemplateApplicationPages({ dispatch, commit }, data) {
    // dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiTemplate.getTemplateApplicationPages(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        commit('setTemplateAppPagesList', res.data);
        // dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
    } catch (err) {
      // dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async actionInstallTemplateApp({ dispatch }, data) {
    // dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiTemplate.installTemplateApp(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        // dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
        // dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
        return res.data;
      }
    } catch (err) {
      // dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async actionInstallTemplatePage({ dispatch }, data) {
    // dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiTemplate.installTemplatePage(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        // dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
        // dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
        return res.data;
      }
    } catch (err) {
      // dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  // PORTAL
  async actionCreatePortal({ dispatch }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiSetting.createPortal(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
      return res;
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
      return err.response.data;
    }
  },

  async actionGetPortalDetail({ dispatch, commit }, { applicationId, param }) {
    // dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiSetting.getPortalDetail(applicationId, param);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        commit('setPortalDetail', res.data);
        // dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
    } catch (err) {
      // dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async actionUpdatePortal({ dispatch }, { applicationId, param }) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiSetting.updatePortal(applicationId, param);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
      return res;
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
      return err.response.data;
    }
  },

  async actionCreatePagePortal({ dispatch }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiSetting.createPagePortal(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
      return res;
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
      return err.response.data;
    }
  },

  async actionGetPagesPortalList({ dispatch, commit }, { applicationId, param }) {
    // dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiSetting.getPagesPortalList(applicationId, param);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        commit('setPagesPortalList', res.data);
        // dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
    } catch (err) {
      // dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async actionGetListIconsPortal({ dispatch }, data) {
    // dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiSetting.getListIconsPortal(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        // dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
      return res;
    } catch (err) {
      // dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
      return err.response.data;
    }
  },

  async actionDeletePagePortal({ dispatch }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiSetting.deletePagePortal(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
      return res;
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
      return err.response.data;
    }
  },

  async actionUpdatePagePortal({ dispatch }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiSetting.updatePagePortal(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
      return res;
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
      return err.response.data;
    }
  },

  async actionGetStandaloneList({ dispatch, commit }, { applicationId, param }) {
    try {
      const res = await apiSetting.getStandaloneList(applicationId, param);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        commit('setStandaloneList', res.data);
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async actionGetCompanySetting({ dispatch, commit }) {
    try {
      const res = await apiSetting.getCompanySetting();
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        commit('setCompanySetting', res.data);
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async actionUpdateCompanySetting({ dispatch }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiSetting.updateCompanySetting(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },
  // payroll company config setting
  async actionGetPayrollCompanyConfig({ dispatch, commit }) {
    try {
      const res = await apiSetting.getPayrollCompanyConfig();
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        commit('setPayrollCompanyConfig', res.data);
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async actionUpdatePayrollCompanyConfig({ dispatch }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiSetting.updatePayrollCompanyConfig(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.messages, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.messages, { root: true });
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message || 'Failed update Payroll Setting', { root: true });
    }
  },

  // Company Setting
  async actionGetUserCompanySetting({ dispatch }, useLoading) {
    if (useLoading) dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiSetting.getUserCompanySetting();
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else if (!res.error) {
        if (useLoading) dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
      return res;
    } catch (err) {
      if (useLoading) dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
      return err.response.data;
    }
  },
  async actionUpdateUserCompanySetting({ dispatch }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiSetting.updateUserCompanySetting(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
      return res;
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
      return err.response.data;
    }
  },
  async actionGetUserCompanySettingV2({ dispatch, commit }, useLoading) {
    if (useLoading) dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiSetting.getUserCompanySettingV2();
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else if (!res.error) {
        if (useLoading) dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
        commit('setUserCompanySetting', res.data);
      }
      return res;
    } catch (err) {
      if (useLoading) dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
      return err.response.data;
    }
  },
  async actionUpdateUserCompanySettingV2({ dispatch }, data) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    try {
      const res = await apiSetting.updateUserCompanySettingV2(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
      return res;
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
      return err.response.data;
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/stores/jStoreSetting.js